import { groupMatchesByRoundName } from 'widgets/fixtures/js/utils/group-matches-by-roundName';

/**
 * Create array from grouped matches
 *
 * Goes through each date in the grouped object and for each day
 * groups the matches by round name and then converts that object into an
 * array, e.g. ['Round 1', {match}, 'Round 2', {match}]
 *
 * @param {object} groupedByDate grouped by date object
 * @returns {Array} groupedByDate array with round name sorted by date
 */
export const createArrayFromGroupedMatches = (groupedByDate) => {
    for (const date in groupedByDate) {
        if (Object.hasOwn(groupedByDate, date)) {
            const groupedByRoundName = groupMatchesByRoundName(
                groupedByDate[date]
            );
            groupedByDate[date] = Object.entries(groupedByRoundName);
        }
    }
    return groupedByDate;
};
